import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import {Chip as Wrapped } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  chip: {
    color: 'rgba(27, 27, 27, 0.54)',
    backgroundColor: 'rgb(225, 225, 225)',
    height: 32,
    borderRadius: 18,
    margin: `0 ${theme.spacing() / 2}px ${theme.spacing() / 2}px 0`,
    maxWidth: '100%',
    cursor: 'pointer'
  },
  label: {
    padding: `0 ${theme.spacing() + 4}px`,
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  delete: {
    color: 'rgba(0, 0, 0, 0.18)',
    width: 20,
    height: 20
  }
})

interface MyProps extends StyledProps {
  label: React.ReactNode,
  onClickDelete?: (e) => void
  draggable?: boolean,
  onDragStart?: (e) => void
  onDragEnd?: (e) => void
  onChipClick?: (e) => void
}

@(withStyles as any)(styles)
export class Chip extends React.Component<MyProps> {
  render() {
    const {
      label,
      classes,
      onClickDelete,
      className,
      draggable,
      onDragStart,
      onDragEnd,
      onChipClick
    } = this.props

    return (
      <Wrapped
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        draggable={draggable}
        classes={{root: classes.chip, deleteIcon: classes.delete, label: classes.label}}
        className={className}
        label={label}
        onDelete={onClickDelete}
        onClick={onChipClick}
        />
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Chip.tsx